import "core-js/modules/es.array.push.js";
import MessageModal from "../common/MessageModal.vue";
import store from "../../services/store.js";
import { mapState } from "vuex";
import { createData, getData, updateData } from "@/services/axios";
import LoadingMessage from "@/components/common/LoadingMessage";
import emailValidator from "email-validator";
import RowItem from "../RowItem";
export default {
  store,
  name: "EditGuardian",
  components: {
    RowItem,
    MessageModal,
    LoadingMessage
  },

  data() {
    return {
      showModalCompleteCreate: false,
      showModalCompleteSave: false,
      messageSentResult: true,
      showModalSelectClass: false,
      showModal: false,
      student: [],
      guardian: {
        name: "",
        ruby: "",
        relationship: "",
        locale: "ja-JP",
        email: "",
        phone: "",
        normal_receive_method: "email",
        emergency_receive_method: "email",
        memo: "",
        role_id: 22,
        target_student_id: this.$route.query.student_id,
        existence_guardian: false
      },
      id: this.$route.params.id,
      isPrimaryGuardian: this.$route.params.guardians === 0,
      questioneeFlagLock: false,
      returnPageId: false,
      isLoading: {
        getData: true,
        postData: false,
        phoneExists: false
      },
      loadingMessage: "",
      error: {
        name: null,
        ruby: null,
        phone: null,
        email: null
      },
      isNewPhone: false,
      isNewPhoneAndEmail: false,
      showModalPhoneExists: false,
      showModalPhoneAndEmailExists: false,
      showModalDuplicativeGuardianExists: false,
      guardianInfoAttached: false,
      foundGuardian: {
        name: "",
        ruby: "",
        relationship: "",
        email: "",
        phone: ""
      }
    };
  },

  computed: { ...mapState(["classrooms", "studentAddress", "me", "capabilities"])
  },

  created() {
    if (this.$store.state.me.role_id > 11) {
      this.$router.push({
        name: "dashboard"
      });
    }

    this.setData();
  },

  methods: {
    validatePhone() {
      return typeof this.guardian.phone === "string" && this.guardian.phone.match(/^\d{10,11}$/);
    },

    checkPhoneExists() {
      this.isNewPhone = false;

      if (!this.guardianInfoAttached && this.validatePhone()) {
        if (emailValidator.validate(this.guardian.email)) {
          this.checkPhoneAndEmailExists();
          return;
        }

        this.isLoading.phoneExists = true; //todo 関係者との電話番号重複チェック

        getData("reader/get_guardian_from_phone?phone=" + this.guardian.phone + (this.id ? "&guardian_id=" + this.id : "")).then(data => {
          if (data.items[0] === null) {
            this.isNewPhone = true;
          } else {
            const guardian = data.items[0];

            if (guardian.guardian_student.length > 0 && guardian.guardian_student.find(v => v.student_id === this.guardian.target_student_id)) {
              this.error.phone = "既にこの電話番号はこの" + this.studentAddress + "に登録されています。別の番号を入力してください。";
              this.guardian.phone = "";
            } else {
              this.showModalPhoneExists = true;
              this.guardian.existence_guardian = guardian.id;
              this.foundGuardian = {
                name: guardian.name,
                ruby: guardian.ruby,
                relationship: guardian.relationship,
                email: guardian.user.email,
                phone: guardian.phone,
                locale: guardian.locale,
                memo: guardian.memo,
                normal_receive_method: guardian.normal_receive_method,
                emergency_receive_method: guardian.emergency_receive_method
              };
            }
          }
        }).catch(error => {
          console.log(error);
        }).then(() => {
          this.isLoading.phoneExists = false;
        });
      }
    },

    checkPhoneAndEmailExists() {
      this.isNewPhoneAndEmail = false;

      if (!this.guardianInfoAttached && this.validatePhone() && emailValidator.validate(this.guardian.email)) {
        this.isLoading.phoneAndEmailExists = true;
        getData(`reader/get_guardian_over_school?phone=${this.guardian.phone}&email=${encodeURIComponent(this.guardian.email)}${this.id ? "&guardian_id=" + this.id : ""}`).then(data => {
          if (data.items[0] === null) {
            this.isNewPhoneAndEmail = true;
          } else {
            const guardian = data.items[0];

            if (guardian.guardian_student.length > 0 && guardian.guardian_student.find(v => v.student_id === this.guardian.target_student_id)) {
              this.error.phone = "既にこの電話番号とメールアドレスはこの" + this.studentAddress + "に登録されています。別の情報を入力してください。";
              this.guardian.phone = "";
            } else {
              this.showModalPhoneAndEmailExists = true;
              this.guardian.existence_guardian = guardian.id;
              this.foundGuardian = {
                name: guardian.name,
                ruby: guardian.ruby,
                relationship: guardian.relationship,
                email: guardian.user.email,
                phone: guardian.phone,
                locale: guardian.locale,
                memo: guardian.memo,
                normal_receive_method: guardian.normal_receive_method,
                emergency_receive_method: guardian.emergency_receive_method
              };
            }
          }
        }).catch(error => {
          console.log(error);
        }).then(() => {
          this.isLoading.isNewPhoneAndEmail = false;
        });
      }
    },

    attachGuardian() {
      this.showModalPhoneExists = false;
      this.showModalPhoneAndEmailExists = false;
      this.guardian.name = this.foundGuardian.name;
      this.guardian.ruby = this.foundGuardian.ruby;
      this.guardian.relationship = this.foundGuardian.relationship;
      this.guardian.email = this.foundGuardian.email;
      this.guardian.phone = this.foundGuardian.phone;
      this.guardian.locale = this.foundGuardian.locale;
      this.guardian.memo = this.foundGuardian.memo;
      this.guardian.normal_receive_method = this.foundGuardian.normal_receive_method;
      this.guardian.emergency_receive_method = this.foundGuardian.emergency_receive_method;
      this.guardianInfoAttached = true;
    },

    cancelAttachGuardian() {
      this.guardian.existence_guardian = false;
      this.showModalPhoneExists = false;
      this.showModalPhoneAndEmailExists = false;
      this.guardianInfoAttached = false;
      this.guardian.phone = "";
      this.foundGuardian = {};
    },

    setData: function () {
      if (this.isPrimaryGuardian) {
        this.guardian.role_id = 21;
      } // params :id が来ている場合は編集なので編集データを取り出す


      if (this.id) {
        getData("guardians/" + this.id + "?with=user").then(data => {
          this.guardian = data.items.map(v => {
            const d = v;
            d.email = d.user.email;
            return d;
          });
          this.guardian = this.guardian[0];
          this.guardian.role_id = this.guardian.user.role_id;
          this.guardian.target_student_id = this.$route.query.student_id;
          this.isPrimaryGuardian = this.questioneeFlagLock = this.guardian.user.role_id === 21;
        }).catch(error => {
          console.log(error);
        }).then(() => {
          this.isLoading.getData = false;
        });
      } else {
        this.isLoading.getData = false;
      }
    },

    postGuardian() {
      createData("writer/write_guardian", {
        guardian: this.guardian
      }).then(data => {
        this.$store.dispatch("commitModalMessage", {
          message: "保護者情報登録が完了しました",
          title: "登録完了"
        });
        this.returnPageId = data.message.student_id;
        this.showModal = true;
      }).catch(error => {
        if (error.response && error.response.status === 409) {
          this.showModalDuplicativeGuardianExists = true;
        }
      }).then(() => {
        this.isLoading.postData = false;
      });
    },

    putGuardian() {
      updateData("writer/write_guardian/" + this.id, {
        guardian: this.guardian
      }).then(data => {
        this.$store.dispatch("commitModalMessage", {
          message: this.studentAddress + "・保護者情報更新が完了しました",
          title: "更新完了"
        });
        this.returnPageId = data.message.student_id;
        this.showModal = true;
      }).catch(error => {
        if (error.response && error.response.status === 409) {
          this.showModalDuplicativeGuardianExists = true;
        }
      }).then(() => {
        this.isLoading.postData = false;
      });
    },

    saveData: function () {
      let valid = true;
      this.error = {
        name: null,
        ruby: null,
        phone: null
      };

      if (!this.guardian.name) {
        this.error.name = "名前を入力してください。";
        valid = false;
      } else {
        this.guardian.name = this.guardian.name.replace(/\s+/, " ");
      }

      if (!this.guardian.ruby) {
        this.error.ruby = "ふりがなを入力してください。";
        valid = false;
      } else {
        this.guardian.ruby = this.guardian.ruby.replace(/\s+/, " ");
      }

      if (!this.guardian.phone) {
        this.error.phone = "電話番号を入力してください。";
        valid = false;
      } else {
        let regex = new RegExp(/^[0-9]+$/);

        if (!regex.test(this.guardian.phone)) {
          this.error.phone = "数字のみで入力してください。";
          valid = false;
        }
      } //緊急のお知らせ無しのプランで、メールアドレスが存在せず電話番号のみのときはバリデーションで止まらないように便宜上emergency_receive_methodをphoneにしてあげる


      if (!this.capabilities.enableEmergencyCall && !this.guardian.email && this.guardian.emergency_receive_method === "email") {
        this.guardian.emergency_receive_method = "phone";
      }

      if (this.guardian.normal_receive_method === "email" || this.guardian.emergency_receive_method === "email" || this.guardian.emergency_receive_method === "both") {
        if (!this.guardian.email) {
          this.error.email = "お知らせ方法にメールを指定している場合はメールアドレスを入力してください。";
          valid = false;
        } else if (!emailValidator.validate(this.guardian.email)) {
          this.error.email = "メールアドレスの形式が正しくありません。";
          valid = false;
        }
      }

      if (!valid) {
        return;
      }

      this.isLoading.postData = true;

      if (this.id) {
        this.loadingMessage = "保護者情報を更新しています。";
        this.putGuardian();
      } else {
        this.loadingMessage = "保護者情報を登録しています。";
        this.postGuardian();
      }
    },

    modalClosed() {
      this.showModal = false;
      this.$router.push({
        name: "students.detail",
        params: {
          id: this.returnPageId
        }
      });
    }

  }
};